<div class="wizard-step-content">
  <div class="d-flex justify-content-between align-items-start mb-4">
    <div>
      <h3 class="mb-2">
        <i class="fa fa-calendar-alt text-primary me-2"></i>
        {{ 'eventWizard.capacity.title' | translate }}
      </h3>
      <p class="text-muted mb-0">
        {{ 'eventWizard.capacity.subtitle' | translate }}
      </p>
    </div>
    @if (hasUnsavedChanges()) {
      <app-button
        [variant]="'primary'"
        [label]="'eventWizard.capacity.saveAll' | translate"
        [iconClass]="'fa fa-save'"
        [disabled]="saving"
        (clicked)="saveAllDays()"
      />
    }
  </div>

  @if (loading) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
      </div>
    </div>
  } @else if (days.length === 0) {
    <div class="empty-state">
      <i class="fa fa-calendar-xmark"></i>
      <h5>{{ 'eventWizard.capacity.noEventDays' | translate }}</h5>
      <p>{{ 'eventWizard.capacity.setDatesFirst' | translate }}</p>
    </div>
  } @else {
    <!-- Day Cards -->
    <div class="days-grid">
      @for (day of days; track day.training_date) {
        <div class="day-card" [class.has-capacity]="day.max_group_sessions > 0 || day.max_individual_sessions > 0">
          <div class="day-header">
            <h5 class="day-label">{{ day.dayLabel }}</h5>
            @if (day.saved && (day.max_group_sessions > 0 || day.max_individual_sessions > 0)) {
              <span class="badge bg-success"><i class="fa fa-check me-1"></i>{{ 'eventWizard.capacity.saved' | translate }}</span>
            } @else if (!day.saved && (day.max_group_sessions > 0 || day.max_individual_sessions > 0)) {
              <span class="badge bg-warning text-dark"><i class="fa fa-clock me-1"></i>{{ 'eventWizard.capacity.unsaved' | translate }}</span>
            }
          </div>

          <div class="day-content">
            <!-- Participants & Sessions -->
            <div class="capacity-section">
              <div class="section-header">
                <i class="fa fa-users text-primary"></i>
                <span>{{ 'eventWizard.capacity.groupSessions' | translate }}</span>
              </div>
              <div class="capacity-inputs">
                <div class="input-group-inline">
                  <label>{{ 'eventWizard.capacity.participants' | translate }}</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    min="0"
                    [(ngModel)]="day.group_session_capacity"
                    (ngModelChange)="onDayChange(day)"
                  />
                </div>
                <div class="input-group-inline">
                  <label>{{ 'eventWizard.capacity.sessionsPerParticipant' | translate }}</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    min="0"
                    [(ngModel)]="day.max_group_sessions"
                    (ngModelChange)="onDayChange(day)"
                  />
                </div>
              </div>
              @if (day.group_session_capacity > 0 && day.max_group_sessions > 0) {
                <div class="capacity-total">
                  = {{ getTotalGroupSlots(day) }} {{ 'eventWizard.capacity.totalSessionSlots' | translate }}
                </div>
              }
            </div>

            <!-- Individual Lessons -->
            <div class="capacity-section">
              <div class="section-header">
                <i class="fa fa-user text-info"></i>
                <span>{{ 'eventWizard.capacity.individualLessons' | translate }}</span>
              </div>
              <div class="capacity-inputs">
                <div class="input-group-inline">
                  <label>{{ 'eventWizard.capacity.lessons' | translate }}</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    min="0"
                    [(ngModel)]="day.max_individual_sessions"
                    (ngModelChange)="onDayChange(day)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="day-footer">
            @if (!day.saved && (day.max_group_sessions > 0 || day.max_individual_sessions > 0)) {
              <app-button
                [variant]="'primary'"
                [label]="'common.save' | translate"
                [size]="'sm'"
                [disabled]="saving"
                (clicked)="saveDay(day)"
              />
            }
          </div>
        </div>
      }
    </div>
  }
</div>
